import React, { Component } from 'react'
import queryString from 'query-string'

import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

const GET_ANSWER = gql`
  query answer($targetYearMonth: String!, $studentCode: ID!, $schoolDivisionCode: String!) {
    surveyMidSchMonthlyQuestions(targetYearMonth: $targetYearMonth, schoolDivisionCode: $schoolDivisionCode) {
      answerRequired
      id
      question
      schoolDivisionCode
      selections
    }
    surveyMidSchMonthlyAnswer(studentCode: $studentCode, targetYearMonth: $targetYearMonth) {
      questionAnswers {
        midSchMonthlyQuestionId
        answers
      }
    }
  }
`

class Reports extends Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {
      allAnswers: []
    }
  }

  render() {
    const { location, match } = this.props
    // console.log(this.props)
    // const officeCode = match.params.officeCode
    const studentCode = match.params.studentCode
    const parsed = queryString.parse(location.search)
    const targetYearMonth = parsed.target_year_month
    const schoolDivisionCode = parsed.division_code
    // console.log(parsed)

    return (
      <Query query={GET_ANSWER} variables={{ targetYearMonth, schoolDivisionCode, studentCode }}>
        {({ data, loading, error }) => {
          if (loading) return <p>毎月チェックの回答を取得中</p>
          if (error) return <p>エラーが発生しました。システム管理者にお問い合せください。</p>


          if (!data.surveyMidSchMonthlyAnswer) {
            return (
              <>
                <Typography variant="h5" component="h1" gutterBottom>
                  毎月チェック回答
                </Typography>

                <p>対象月の毎月チェックの回答はありません。</p>
              </>
            )
          } else {
            return (
              <>
                <Typography variant="h5" component="h1" gutterBottom>
                  毎月チェック回答
                </Typography>

                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[0].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[0].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[1].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[1].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[2].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[2].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[3].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[3].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[4].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[4].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[5].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[5].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[6].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[6].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[7].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[7].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
                <Box my={5}>
                  <p><strong>{data.surveyMidSchMonthlyQuestions[8].question}</strong></p>
                  <ul>
                    {data.surveyMidSchMonthlyAnswer.questionAnswers[8].answers.map(answer => (
                      <li>{answer}</li>
                    ))}
                  </ul>
                </Box>
              </>
            )
          }
        }}
      </Query>
    )
  }

}

export default Reports
